const validEmailRegex = new RegExp(/\S+@\S+\.\S+/);

const isEmailAddressValid = (email: string) => {
  const emailWithoutWhitespace = email.replace(/\s/g, '');
  return validEmailRegex.test(emailWithoutWhitespace);
};

export default isEmailAddressValid;
